export const CONNECTION_STATUS = {
  GOOD: 'good',
  UNSTABLE: 'unstable',
  ERROR: 'error',
  RECONNECTING: 'reconnecting',
}

let instance = null

class SystemConnection {
  constructor() {
    if (instance) {
      return instance
    }

    instance = this
  }

  initEventHandlers(eventHandlers) {
    this.eventHandlers = {
      ...this.eventHandlers,
      ...eventHandlers,
    }
  }

  detectUserConnection() {
    const status = navigator.onLine ? CONNECTION_STATUS.GOOD : CONNECTION_STATUS.ERROR
    this.eventHandlers.onUserConnectionUpdate(status)
    window.addEventListener('online', () => this.eventHandlers.onUserConnectionUpdate(CONNECTION_STATUS.GOOD))
    window.addEventListener('offline', () => this.eventHandlers.onUserConnectionUpdate(CONNECTION_STATUS.ERROR))
  }

  detectSocketConnection(status) {
    if (!this.eventHandlers) return
    this.eventHandlers.onSocketConnectionUpdate(status)
  }

  detectEmqxConnection(status) {
    if (!this.eventHandlers) return
    this.eventHandlers.onEmqxConnectionUpdate(status)
  }

  detectGeneralConnection(status) {
    if (!this.eventHandlers) return
    this.eventHandlers.onGeneralConnectionUpdate(status)
  }

  detectLiveApiConnection(status) {
    if (!this.eventHandlers) return
    this.eventHandlers.onLiveApiConnectionUpdate(status)
  }
}

const systemConnection = new SystemConnection()
export default systemConnection
